import React from 'react'
import { Icon, Button } from 'components/atoms'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import { Tooltip } from 'components/molecules';

const Device = ({
  option, onClick, isActive, isDisabled
}) => {
  const { label, icon } = option

  return (
    <Tooltip tooltip={`Pré-visualizar num ${label}`} placement="bottom">
      <DeviceButton
        modifiers={['small', 'invisible']}
        onClick={() => onClick(option)}
        isActive={isActive}
      >
        <ActiveLine isActive={isDisabled ? false : isActive} />
        <Icon icon={icon} height={20} />
      </DeviceButton>
    </Tooltip>
  )
}


Device.propTypes = {
  option: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string,
  }),
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

Device.defaultProps = {
  option: {},
  onClick: () => { },
  isActive: false,
  isDisabled: false,
}

const ResponsiveViewerSelect = ({
  options, value, onChange, isDisabled
}) => {
  const handleOnClick = (optionClicked) => {
    if (isDisabled) return;
    onChange(optionClicked)
  }

  return (
    <Wrapper>
      {options.map(option => (
        <Device
          key={option.value}
          option={option}
          onClick={handleOnClick}
          isActive={value.value === option.value}
          isDisabled={isDisabled}
        />
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`


const ActiveLine = styled.div`
  width: ${props => (props.isActive ? '100%' : '0%')};
  height: 2px;
  background-color: ${props => props.theme.colors.base};
  transition: width 0.2s;
  border-radius: 8px;
  margin-bottom: ${props => props.theme.spacing.xs2};
`

const DeviceButton = styled(Button)`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.xs2} ${props => props.theme.spacing.xs3};
  padding-top: 0;
  &:hover {
    ${ActiveLine} {
      width: ${props => (props.isActive ? '100%' : '50%')};
    }
  }
`

ResponsiveViewerSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      icon: PropTypes.string,
    })),
  value: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string,
  }),
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
}

ResponsiveViewerSelect.defaultProps = {
  options: [],
  value: {},
  onChange: () => { },
  isDisabled: false,
}

export default ResponsiveViewerSelect
